import styled, { css } from 'styled-components';
import { baseColors } from '@groupby/ui-components';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { Button } from '@/components/button';
export const StyledTableHead = styled(TableHead) `
  position: sticky;
  z-index: 5;
  top: 0;
  background-color: ${baseColors.white};
  height: 3.5rem;
`;
export const StyledTableHeadCell = styled(TableCell) `
  && {
    cursor: default;
    width: ${({ width }) => width || 'unset'};
    min-width: ${({ width, minWidth }) => minWidth || width || 'unset'};
    max-width: ${({ width, maxWidth }) => maxWidth || width || 'unset'};

    z-index: 3;
    position: ${({ sticky }) => (sticky ? 'sticky' : 'unset')};
    left: ${({ left }) => (typeof left === 'number' ? `${left}px` : 'unset')};
    background-color: ${baseColors.white};
  }

  &.MuiTableCell-alignCenter [aria-label] {
    width: 100%;
    margin-right: 1rem;
  }
`;
export const StyledBulkActionContainer = styled(TableRow) `
    position: fixed;
    &&&.MuiTableRow-root {
      background-color: ${baseColors.background000};
    }
    th&&&.MuiTableCell-root,
    &&& th.MuiTableCell-root {
      background-color: ${baseColors.background000};
    }

    z-index: 4;
    width: ${({ width }) => width};

    th {
      height: 3.5rem;
      box-sizing: border-box;
    }
`;
export const StyledBulkActionButtonsContainer = styled.div `
    padding: 0 0.5rem;
`;
export const StyledTableHeader = styled.div `
  display: flex;
  align-items: center;
  border-left: 1px solid ${baseColors.background000};
  padding-left: 1rem;

  &:last-of-type {
    border-right: 1px solid ${baseColors.background000};
  }
`;
export const StyledFilterButton = styled(Button) `
  && {
    svg path {
      ${({ $isActive }) => `stroke: ${$isActive ? baseColors.primaryGreen400 : baseColors.primaryBlueMed400}`};
      ${({ $isActive }) => `fill: ${$isActive ? baseColors.primaryGreen400 : baseColors.white}`};
    }

    &:hover {
      svg path {
        ${({ $isActive }) => `fill: ${$isActive ? baseColors.primaryGreen400 : baseColors.white}`};
        ${({ $isActive }) => !$isActive && `stroke: ${baseColors.primaryGreen400}`};
      }
    }
  }
`;
export const StyledSortButton = styled(Button) `
  && {
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
    transition: opacity 0.15s ease-in-out;

    svg {
      ${({ $desc }) => !$desc && css `transform: rotate(180deg)`};

      path {
        ${({ $isActive }) => !$isActive && `fill: ${baseColors.primaryBlueMed400}`}};
      }
    }
  }
`;
